
export default function PartnerBenefits() {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-900 to-blue-800 text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-extrabold mb-6" style={{ textShadow: '0 3px 8px rgba(0,0,0,0.5)' }}>
            Quyền Lợi Đối Tác
          </h2>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto font-bold" style={{ textShadow: '0 2px 6px rgba(0,0,0,0.5)' }}>
            Hợp tác cùng chúng tôi để nhận được những ưu đãi đặc biệt
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Benefit 1 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/20 transition-all duration-300 border border-white/20">
            <div className="flex items-start mb-6">
              <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-percent-line text-3xl"></i>
              </div>
              <div>
                <h3 className="text-2xl font-extrabold mb-3" style={{ textShadow: '0 2px 6px rgba(0,0,0,0.5)' }}>
                  Chiết Khấu Hấp Dẫn
                </h3>
                <p className="text-lg leading-relaxed font-bold" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>
                  Giảm giá đặc biệt cho đối tác dài hạn và đoàn lớn, hoa hồng cạnh tranh cho mỗi chuyến đi.
                </p>
              </div>
            </div>
          </div>

          {/* Benefit 2 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/20 transition-all duration-300 border border-white/20">
            <div className="flex items-start mb-6">
              <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-calendar-check-line text-3xl"></i>
              </div>
              <div>
                <h3 className="text-2xl font-extrabold mb-3" style={{ textShadow: '0 2px 6px rgba(0,0,0,0.5)' }}>
                  Ưu Tiên Đặt Lịch
                </h3>
                <p className="text-lg leading-relaxed font-bold" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>
                  Đối tác được ưu tiên đặt xe trong mùa cao điểm, đảm bảo luôn có xe phục vụ khi cần.
                </p>
              </div>
            </div>
          </div>

          {/* Benefit 3 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/20 transition-all duration-300 border border-white/20">
            <div className="flex items-start mb-6">
              <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-file-text-line text-3xl"></i>
              </div>
              <div>
                <h3 className="text-2xl font-extrabold mb-3" style={{ textShadow: '0 2px 6px rgba(0,0,0,0.5)' }}>
                  Hợp Đồng Linh Hoạt
                </h3>
                <p className="text-lg leading-relaxed font-bold" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>
                  Điều khoản hợp đồng rõ ràng, linh hoạt, phù hợp với nhu cầu kinh doanh của đối tác.
                </p>
              </div>
            </div>
          </div>

          {/* Benefit 4 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/20 transition-all duration-300 border border-white/20">
            <div className="flex items-start mb-6">
              <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-hand-heart-line text-3xl"></i>
              </div>
              <div>
                <h3 className="text-2xl font-extrabold mb-3" style={{ textShadow: '0 2px 6px rgba(0,0,0,0.5)' }}>
                  Hỗ Trợ Marketing
                </h3>
                <p className="text-lg leading-relaxed font-bold" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>
                  Cung cấp tài liệu, hình ảnh xe, video quảng bá để đối tác dễ dàng giới thiệu dịch vụ.
                </p>
              </div>
            </div>
          </div>

          {/* Benefit 5 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/20 transition-all duration-300 border border-white/20">
            <div className="flex items-start mb-6">
              <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-money-dollar-circle-line text-3xl"></i>
              </div>
              <div>
                <h3 className="text-2xl font-extrabold mb-3" style={{ textShadow: '0 2px 6px rgba(0,0,0,0.5)' }}>
                  Thanh Toán Thuận Tiện
                </h3>
                <p className="text-lg leading-relaxed font-bold" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>
                  Nhiều hình thức thanh toán: chuyển khoản, tiền mặt, thẻ tín dụng, công nợ theo thỏa thuận.
                </p>
              </div>
            </div>
          </div>

          {/* Benefit 6 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/20 transition-all duration-300 border border-white/20">
            <div className="flex items-start mb-6">
              <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-customer-service-line text-3xl"></i>
              </div>
              <div>
                <h3 className="text-2xl font-extrabold mb-3" style={{ textShadow: '0 2px 6px rgba(0,0,0,0.5)' }}>
                  Quản Lý Tài Khoản
                </h3>
                <p className="text-lg leading-relaxed font-bold" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>
                  Mỗi đối tác có nhân viên chăm sóc riêng, hỗ trợ nhanh chóng mọi yêu cầu và thắc mắc.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
